import React from 'react';
import ReportHeader from '../../components/reports/shared/report-header';
import CandidateDevelopmentReportRecommendations from '../../components/reports/candidate-development-report/candidate-development-report-recommendations';
import ReportPdfHeader from '../../components/reports/shared/report-pdf-header';
import { REPORT_TYPE } from '../../utils/constants';
import { isStaffingCandidate } from '../../api/dashboards-api';

function CandidateDevelopmentReport({ candidate }) {
  const classification = isStaffingCandidate(candidate) ? REPORT_TYPE.staffing : REPORT_TYPE.coaching;
  return (
    <>
      <div className="print-page print-heading">
        <ReportPdfHeader />
        <ReportHeader candidate={candidate} header="Candidate Development Report" nameOnly={true} />
        <CandidateDevelopmentReportRecommendations candidate={candidate} reportType={classification} />
      </div>
    </>
  );
}

export default CandidateDevelopmentReport;
